import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import toast from "react-hot-toast";
import { TbPencil } from "react-icons/tb";
import PhoneNumber from "../../components/auth/phoneNumber";
import Password from "../../components/auth/password";
import Otp from "../../components/auth/otp";
import useStore from "../../features/store";
import { messaging, getToken, deleteToken } from "../../firebase";
import {
  checkMobilePassword,
  loginWithMobile,
  registerDevice,
} from "../../services/auth";

const Login = () => {
  const navigate = useNavigate();
  const optNumber = localStorage.getItem("y_phone");
  //@ts-ignore
  const { profile, fetchProfile } = useStore();

  const [phoneNumber, setPhoneNumber] = useState("");
  const [isOtp, setIsOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [mobileCheckLoading, setMobileCheckLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  function getPlatform() {
    const userAgent = navigator.userAgent.toLowerCase();

    if (/iphone|ipad|ipod/g.test(userAgent)) {
      return "ios";
    } else if (/android|blackberry/g.test(userAgent)) {
      return "android";
    } else {
      return "web";
    }
  }

  useEffect(() => {
    if (phoneNumber && profile) {
      localStorage.removeItem("y_phone");
      localStorage.removeItem("y_date");

      if (profile?.user?.first_name && profile?.user?.last_name) {
        navigate("/");
      } else {
        navigate("/update-profile");
      }
    }
  }, [profile]);

  const setNewPhoneNumberHandler = (identifier: number) => {
    if (identifier !== Number(optNumber)) {
      localStorage.removeItem("y_phone");
      localStorage.removeItem("y_date");
    }
    setPhoneNumber(`${identifier}`);
  };

  const checkMobileHandler = async (identifier: number) => {
    setMobileCheckLoading(true);

    try {
      const hasPassword = await checkMobilePassword(identifier);
      setMobileCheckLoading(false);

      if (hasPassword?.data) {
        if (hasPassword?.data?.message?.has_password) {
          setIsOtp(false);
          setNewPhoneNumberHandler(identifier);
        } else {
          setIsOtp(true);
          setNewPhoneNumberHandler(identifier);
        }
      }
    } catch (err) {}
  };

  // const registerNotification = async () => {
  //   const clearExistingToken = async () => {
  //     try {
  //       const currentToken = await getToken(messaging, {
  //         vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
  //       });
  //       if (currentToken) {
  //         await deleteToken(messaging);
  //       }
  //     } catch (err) {}
  //   };

  //   const requestPermission = async () => {
  //     try {
  //       const permission = await Notification.requestPermission();
  //       if (permission === "granted") {
  //         await clearExistingToken();

  //         const token = await getToken(messaging, {
  //           vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
  //         });

  //         if (token) {
  //           await registerDevice(token, getPlatform());
  //         }
  //       }
  //     } catch (err) {}
  //   };

  //   try {
  //     await requestPermission();
  //   } catch (err) {}
  // };

  const loginHandler = async (code: number) => {
    try {
      const login = await loginWithMobile(phoneNumber, code);

      if (login.status === 202) {
        localStorage.setItem("access_token", login.data.access);
        localStorage.setItem("refresh_token", login.data.refresh);

        setTimeout(() => {
          fetchProfile();
        }, 100);
        // registerNotification();
      }
    } catch (err) {
      setLoading(false);
      setOtp("");

      toast.error(
        isOtp ? "کد وارد شده معتبر نمی‌باشد" : "رمز عبور معتبر نمی‌باشد"
      );
    }
  };

  return (
    <div className="relative flex-1 flex flex-col mx-auto pt-16 pb-6 max-h-[550px] lg:max-h-[700px] lg:px-0 px-2">
      <h1 className="text-center text-5xl font-bold mb-8">ورود</h1>
      <p className="text-center max-w-md">
        برای استفاده از تمام امکانات{" "}
        <strong className="text-pr_primary">بادی‌بان</strong> لازم است وارد
        شوید.
      </p>

      {phoneNumber && (
        <div className="flex items-center justify-between mt-14 mb-4">
          <h6 className="font-bold tracking-widest">{phoneNumber}</h6>
          <span
            className="text-blue-500 text-sm cursor-pointer flex items-center"
            onClick={() => setPhoneNumber("")}
          >
            <TbPencil size={18} className="ml-1" />
            تغییر شماره موبایل
          </span>
        </div>
      )}

      {!phoneNumber ? (
        <PhoneNumber
          checkMobileHandler={checkMobileHandler}
          mobileCheckLoading={mobileCheckLoading}
        />
      ) : isOtp ? (
        <Otp
          phoneNumber={phoneNumber}
          setIsOtp={setIsOtp}
          loginHandler={loginHandler}
          otp={otp}
          setOtp={setOtp}
          loading={loading}
          setLoading={setLoading}
        />
      ) : (
        <Password
          phoneNumber={phoneNumber}
          setIsOtp={setIsOtp}
          loginHandler={loginHandler}
          loading={loading}
          setLoading={setLoading}
        />
      )}
    </div>
  );
};

export default Login;
